/**
 * Map tile layer configuration shared by every Leaflet map in the app.
 *
 * - Defaults to the app's own /api/map-tiles proxy: tiles are fetched
 *   server-side with a policy-compliant identity, so viewers' networks can
 *   never trigger upstream "Access blocked" responses.
 * - Sets an explicit referrerPolicy on every tile <img> as a fallback for any
 *   externally-hosted tile URL configured per environment.
 * - Each environment (dev/test/prod) can point at its own tile server at build
 *   time via REACT_APP_MAP_TILE_URL / REACT_APP_MAP_TILE_ATTRIBUTION /
 *   REACT_APP_MAP_MAX_ZOOM (e.g. direct OSM, a self-hosted, or a commercial
 *   tile provider).
 */
export const DEFAULT_TILE_URL = '/api/map-tiles/{z}/{x}/{y}.png';
export const DEFAULT_TILE_ATTRIBUTION =
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
export const DEFAULT_MAX_ZOOM = 19;
export const TILE_REFERRER_POLICY = 'strict-origin-when-cross-origin';

/**
 * Resolve tile layer options for the current environment.
 * @param {object} env - environment variables (defaults to the CRA build-time env)
 * @returns {{url: string, attribution: string, maxZoom: number, referrerPolicy: string}}
 */
export const getTileLayerConfig = (env = process.env) => {
    const maxZoom = parseInt(env.REACT_APP_MAP_MAX_ZOOM, 10);
    return {
        url: env.REACT_APP_MAP_TILE_URL || DEFAULT_TILE_URL,
        attribution: env.REACT_APP_MAP_TILE_ATTRIBUTION || DEFAULT_TILE_ATTRIBUTION,
        maxZoom: maxZoom > 0 ? maxZoom : DEFAULT_MAX_ZOOM,
        referrerPolicy: TILE_REFERRER_POLICY,
    };
};
